import { render, staticRenderFns } from "./Reduce_debt.vue?vue&type=template&id=124612b1&scoped=true&"
import script from "./Reduce_debt.vue?vue&type=script&lang=js&"
export * from "./Reduce_debt.vue?vue&type=script&lang=js&"
import style0 from "./Reduce_debt.vue?vue&type=style&index=0&id=124612b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124612b1",
  null
  
)

export default component.exports